<template>
  <div class="hidden-sm-and-down">
    <v-parallax :src="require('../assets/tigr2.png')">
      <v-layout row>
        <v-flex md12>
          <v-layout row justify-space-between fill-height align-end>
            <v-flex md3>
              <router-link to="/">
                <v-img :src="require('../assets/logo.png')" contain height="220"></v-img>
              </router-link>
            </v-flex>
            <v-flex md8 class="title">
              <p class="display-2 font-weight-bold">Клуб спортивного карате</p>
              <p class="display-3 font-weight-bold">МАЯК - Северо-Восток</p>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-parallax>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.title {
  color: white;
  text-shadow: 3px 1px 0px #000000;
}
</style>
